import styled, { css } from 'styled-components'
import { Dialog as DdsDialog, getFontStyle } from '@diversioteam/diversio-ds'

export const Dialog = styled(DdsDialog)<{ isLoading: boolean }>`
    .MuiDialog-paper {
        margin-left: 250px;
        padding: 30px;
        min-width: 450px;
        max-width: 550px;
        width: 100%;
        display: flex;
        flex-direction: column;
        pointer-events: ${({ isLoading }) => {
            if (isLoading) {
                return 'none'
            }
        }};
    }

    .dds-button {
        overflow: hidden;
    }
`

export const Title = styled.h2`
    margin: 0 0 20px;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('cardHeaderBold')}
`

export const SectionWrapper = styled.section<{ isLoading: boolean }>`
    width: 100%;
    position: relative;

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: ${({ theme }) => theme.colors.primaryWhite};
        opacity: 0;
        z-index: 1;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }

    ${({ isLoading }) =>
        isLoading &&
        css`
            &::after {
                opacity: 0.8;
                pointer-events: auto;
            }
        `}
`

export const Section = styled.section`
    display: flex;
    flex-direction: column;
    padding: 20px 0;
    border-top: 1px dashed ${({ theme }) => theme.colors.primaryGray2};
    border-bottom: 1px dashed ${({ theme }) => theme.colors.primaryGray2};
`

export const SectionTitle = styled.h3`
    margin: 0;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p02Medium')}
`

export const Required = styled.span`
    display: block;
    margin-top: 6px;
    color: ${({ theme }) => theme.colors.lobsterSharp};

    ${getFontStyle('p03Regular')}
`

export const PrivacyOptions = styled.div`
    margin: 20px 0 14px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`

export const PrivacyOption = styled.div<{ selected: boolean }>`
    padding: 18px;
    border-radius: 12px;
    min-width: 200px;
    width: 100%;
    flex: 1;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    border: 1.5px solid ${({ theme }) => theme.colors.secondary100Transparent};
    position: relative;

    ${({ selected, theme }) =>
        selected &&
        css`
            &::before {
                content: '';
                position: absolute;
                top: -1px;
                right: -1px;
                bottom: -1px;
                left: -1px;
                border: 4px solid ${theme.colors.primary40};
                border-radius: 12px;
                pointer-events: none;
            }
        `}
`

export const PrivacyOptionIcon = styled.div`
    position: absolute;
    top: 18px;
    right: 18px;
`

export const PrivacyOptionTitle = styled.h4`
    margin: 0 0 8px;
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p02Medium')}
`

export const PrivacyOptionDescription = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p03Regular')}

    span {
        ${getFontStyle('p03Semibold')}
    }
`

export const PrivacyOptionList = styled.ul`
    margin: 18px 0 24px;
    padding: 0 0 0 18px;
`

export const PrivacyOptionListItem = styled.li`
    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p03Regular')}
`

export const SwitchWrapper = styled.div`
    margin-top: 12px;
    padding: 14px 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    border: 1.5px solid ${({ theme }) => theme.colors.secondary100Transparent};
    border-radius: 12px;

    ${getFontStyle('p02Regular')}
`

export const SwitchLabel = styled.span`
    flex: 1;
    color: ${({ theme }) => theme.colors.secondary500};
    white-space: pre-wrap;

    ${getFontStyle('p03Regular')}
`

export const InputWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0 0;

    .dds-text-field {
        width: 148px;

        .MuiInputBase-input {
            padding: 12px;
        }
    }
`

export const InputLabel = styled.div`
    color: ${({ theme }) => theme.colors.primary90};

    ${getFontStyle('p02Medium')}
`

export const Summary = styled.p`
    margin: 20px 0;
    text-align: center;

    ${getFontStyle('p02Regular')}
`

export const ErrorSummary = styled(Summary)`
    text-align: center;
    color: ${({ theme }) => theme.colors.lobsterSharp};
`

export const Buttons = styled.div`
    display: flex;
    gap: 12px;
`
